module.exports = ".global {\n  text-align: center;\n  width: 100%;\n  max-width: 1200px;\n  margin: auto; }\n\nh1 {\n  margin: 100px;\n  font-size: 4em;\n  text-shadow: 2px 2px 2px white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main